module.exports = __webpack_public_path__ + "img/bosnia.bd9d5ff8.svg";